import { StatusCodes } from "http-status-codes";
import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { AtomicType } from "../../../types/atomic.types";
import { HasSpouseDetailsQueryType } from "../../../types/employee.types";
import { Member } from "../../../types/member.types";
import { Paycheck } from "../../../types/paycheck.types";
import { request } from "../api";
import { Payload } from "../../../types/api/api.types";

const { get } = request;
const initialRoute = "group/member";
const { Authorization, Bearer } = AUTHORIZATION;
type GetMember = {
	profile: Member;
	paycheck: Paycheck | null;
};

type Dependents = {
	FIRSTNAME: string;
	LASTNAME: string;
	SPOUSE: "T" | "F";
	CHILD: "T" | "F";
	OTHER: "T" | "F";
	[key: string]: AtomicType;
};

export const getMember = async (): Promise<GetMember> => {
	try {
		const endpoint = initialRoute;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getDependents = async (): Promise<Dependents[]> => {
	try {
		const endpoint = `${initialRoute}/dependents`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getExistsMemberEnrollemnt = async (payload: any): Promise<any> => {
	try {
		const endpoint = "member/get-exists-member-enrollment";
		const token = localStorage.getItem("@jwt_member");
		const member_SSN = payload.member_SSN;
		const employee_SSN = payload.employee_SSN;
		const url = `${endpoint}?member_SSN=${encodeURIComponent(member_SSN)}&employee_SSN=${encodeURIComponent(
			employee_SSN
		)}`;
		const response = await get(url, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("responseCheckforthis", result);
				return result;
			}
		}

		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getSpouseDetailsByEmployeeSSN = async (hasSpouseDetailsQuery: HasSpouseDetailsQueryType) => {
	try {
		const endpoint = "member/get-spouse-by-employee-ssn";
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `${Bearer} ${token}`
			},
			hasSpouseDetailsQuery
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ || message === "Spouse does not exists!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const member = {
	getMember,
	getDependents,
	getSpouseDetailsByEmployeeSSN,
	getExistsMemberEnrollemnt
};
